import { $subscription } from './states';
import { fetchSubscription } from './effects';

import '../modals/CreatePlanToPriceAttachmentModal/store/init';

// Fetch subscription
$subscription.on(fetchSubscription.doneData, (_, data) => data);
